/**
 * La barra fija de abajo (06-patrones-pantalla §1.5 y §8.4).
 *
 * Es local a `listas/` porque hoy son las dos unicas barras sticky de pagina
 * del sistema (aplicar y revertir) y compartian la misma cadena de quince
 * clases copiada. Sin sombra: `shadow-lg` es de overlays (MASTER §2.3) y una
 * barra pegada abajo no lo es; el `border-t` alcanza para separarla.
 *
 * La zona segura del iPhone la pone el contenedor de afuera
 * (`area-segura-abajo`) y el `py-3` va adentro, como en el ticket.
 */
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface BarraAccionesProps {
  /** Contexto a la izquierda: el badge de estado y el resumen. */
  resumen?: ReactNode;
  /** Las acciones, a la derecha; la primaria ultima. */
  children: ReactNode;
  /**
   * `pagina`: se come el padding del `main` (`p-4 md:p-6`) para llegar a los
   * bordes; el breakpoint vive aca y no en cada pantalla.
   */
  sangria?: "pagina" | "ninguna";
  className?: string;
}

const SANGRIA = {
  pagina: { afuera: "-mx-4 md:-mx-6", adentro: "px-4 md:px-6" },
  ninguna: { afuera: "", adentro: "px-4" },
} as const;

export function BarraAcciones({
  resumen,
  children,
  sangria = "ninguna",
  className,
}: BarraAccionesProps): JSX.Element {
  return (
    <div
      className={cn(
        "area-segura-abajo sticky bottom-0 z-20 border-t border-border bg-card",
        SANGRIA[sangria].afuera,
        className,
      )}
    >
      <div
        className={cn(
          "flex flex-wrap items-center justify-between gap-3 py-3",
          SANGRIA[sangria].adentro,
        )}
      >
        {resumen ? (
          <div className="flex min-w-0 flex-wrap items-center gap-2 text-sm">{resumen}</div>
        ) : null}
        {/* En mobile la accion se estira sola en su fila; en sm+ vuelve a su ancho. */}
        <div className="flex w-full items-center gap-2 sm:w-auto [&>*]:flex-1 sm:[&>*]:flex-none">
          {children}
        </div>
      </div>
    </div>
  );
}
